import {FormDrawer} from './FormDrawer.tsx';
import {DrawerProps} from '@mantine/core';

export const AddFormDrawer = (props: DrawerProps) => {
    return (
        <FormDrawer {...props} />
    )
};
